module.exports = __webpack_public_path__ + "img/Icn_M_Briefcase.2b1b5595.svg";